import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Contact } from "../../ContactManager/model/contact";
import { PaginationModel } from "../model/organization";
import { addContactsToOrganization, fetchContactsInOrganization } from "./asyncThunks";

export const initialContactsListState = {
    contacts: [] as Contact[],
    pagination: {
        startRow: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 50, 100],
        totalRowCount: 0,
    } as PaginationModel,
};

export const contactListInOrganizationSlice = createSlice({
    name: "contactListInOrganization",
    initialState: initialContactsListState,
    reducers: {
        onChangeContactPage: (state, action): void => {
            state.pagination.startRow = action.payload;
        },
        onChangeContactRowPerPage: (state, action): void => {
            state.pagination.rowsPerPage = action.payload;
        },
    },
    extraReducers: {
        [`${fetchContactsInOrganization.fulfilled}`]: (state, action): void => {
            state.contacts = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.contacts.length;
        },
        [`${addContactsToOrganization.fulfilled}`]: (state, action): void => {
            state.contacts = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.contacts.length;
        },
    },
});

// Actions
export const { onChangeContactPage, onChangeContactRowPerPage } = contactListInOrganizationSlice.actions;

// Selectors
export const contactsInOrganizationSelector = (state: RootState) => state.contactListInOrganization.contacts;

export const contactsInOrganizationPaginationSelector = (state: RootState): PaginationModel =>
    state.contactListInOrganization.pagination;
